import { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabase';
import { errorMessage } from './format';

// Small helper for the many "load all rows from a table" screens.
// Returns the rows plus a `reload` you call after a mutation.
export function useTable<T>(
  table: string,
  orderColumn: string,
  opts: { ascending?: boolean } = {},
) {
  const ascending = opts.ascending ?? true;
  const [rows, setRows] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from(table)
      .select('*')
      .order(orderColumn, { ascending });
    if (error) {
      setError(errorMessage(error));
    } else {
      setRows((data ?? []) as T[]);
      setError(null);
    }
    setLoading(false);
  }, [table, orderColumn, ascending]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { rows, loading, error, reload };
}
